import { Outlet } from "react-router-dom";

export default function TaskCreator() {
  return <Outlet />;
}
